import * as loadjs from 'loadjs'
import Blacklist from '../blacklist/Blacklist'
import { LoadJsBundle } from '../enums/LoadJsBundle'
import { Device } from '../helpers'
import { domReady } from '../helpers/DOM'
import WebModel from '../models/WebModel'

export const ZERGNET_URL = '//www.zergnet.com/zerg.js'

export default class Zergnet {
  constructor(model: WebModel, blacklist: Blacklist) {
    domReady(() => {
      if (blacklist.all || blacklist.contains('zergnet')) {
        return this
      }

      if (
        !(
          model.zergnet &&
          model.zergnet_id &&
          (model.zergnet_content_selector || model.content_selector)
        )
      ) {
        return this
      }

      const zergnetSelector = this.getZergnetSelector(model)
      const selector = document.querySelector(zergnetSelector)

      if (selector) {
        let widgetHtml = `<div id="zergnet-widget-${model.zergnet_id}"></div>`
        if (model.zergnet_traffic_id) {
          widgetHtml += `<div id="zergnet-widget-${model.zergnet_traffic_id}"></div>`
        }
        const zergnetPosition = model.zergnet_content_position
          ? model.zergnet_content_position
          : 'afterend'

        selector.insertAdjacentHTML(zergnetPosition, widgetHtml)

        loadjs(`${ZERGNET_URL}?id=${model.zergnet_id}`, LoadJsBundle.zergnet_id)
        if (model.zergnet_traffic_id) {
          loadjs(
            `${ZERGNET_URL}?id=${model.zergnet_traffic_id}`,
            LoadJsBundle.zergnet_traffic_id
          )
        }
      }

      return this
    })
  }

  private getZergnetSelector(model): string {
    let zergnetSelector
    if (model.zergnet_content_selector) {
      zergnetSelector = model.zergnet_content_selector
    } else if (model.content_selector_mobile && Device.isMobileOrTablet) {
      zergnetSelector = model.content_selector_mobile
    } else {
      zergnetSelector = model.content_selector
    }

    return zergnetSelector
  }
}
